import { useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';

import { StudioModalName } from '@cartwhl/common/stores/navigationStore';
import Modal from '@cartwhl/ui/molecules/Modal';

import { navigationStore } from 'stores';

import { BROWSE_DESKTOP_MIN_WIDTH } from '../constants';
import BrowseMotionContent from './BrowseMotionContent';

const getModalWidth = () => {
  const screenWidth = window.innerWidth;

  if (screenWidth <= 2000) return BROWSE_DESKTOP_MIN_WIDTH;

  // Scale motion library size from 1024 to 1920 between webpage widths of 2001-2400
  if (screenWidth <= 2400) {
    const progress = (screenWidth - 2001) / (2400 - 2001);
    return Math.round(
      BROWSE_DESKTOP_MIN_WIDTH + (1920 - BROWSE_DESKTOP_MIN_WIDTH) * progress,
    );
  }

  // Plateau motion library size at 1920 between webpage widths of 2401-2600
  if (screenWidth <= 2600) {
    return 1920;
  }

  // Scale motion library size from 1920 to 2560 between webpage widths of 2601-3400
  if (screenWidth <= 3400) {
    const progress = (screenWidth - 2601) / (3400 - 2601);
    return Math.round(1920 + (2560 - 1920) * progress);
  }

  return 2560; // Max motion library width for screens > 3400
};

export default function BrowseMotionsModal({
  close,
  prefillSearchTerm,
  browseItemJobId,
}: {
  close: () => void;
  prefillSearchTerm?: string;
  browseItemJobId?: string;
}) {
  const { modal } = useSnapshot(navigationStore.state);
  const [modalWidth, setModalWidth] = useState(getModalWidth());

  useEffect(() => {
    const handleResize = () => {
      setModalWidth(getModalWidth());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Modal
      open={modal?.type === StudioModalName.BROWSE}
      onOpenChange={() => {
        if (modal?.type === StudioModalName.BROWSE) {
          navigationStore.closeModal();
        }
      }}
      verticalBleed
      horizontalBleed
      maxWidth={modalWidth}
    >
      <BrowseMotionContent
        close={close}
        prefillSearchTerm={prefillSearchTerm}
        browseItemJobId={browseItemJobId}
      />
    </Modal>
  );
}
